import api from "@/lib/axios";
import { unwrap } from "@/lib/strapi";

/**
 * Guest ordering. There is no login: creating an order returns a private
 * access token, and that token is the only way to read the order back.
 * The backend deliberately exposes no list endpoint.
 */
export const ordersApi = {
  create: async (data) => unwrap(await api.post("/orders", { data })),
  track: async (token) => unwrap(await api.get(`/orders/track/${token}`)),
  createCustom: async (data) => unwrap(await api.post("/custom-orders", { data })),
  trackCustom: async (token) => unwrap(await api.get(`/custom-orders/track/${token}`)),
};
